import {
  ButtonWrapper,
  Content,
  Subtitle,
  ExtraLabel,
  UpperLabel,
  EnrollButtonWrapper,
  EnrollContainer,
  FixedWrapper,
} from './styles';
import { formattedTitle } from '@/utils/formatted-title';
import { Heading } from '@swordhealth/ui-corporate';
import EnrollButton from '@/app/components/core/EnrollButton';
import { useInView } from 'react-intersection-observer';
import useBetterMediaQuery from '@/utils/useBetterMediaQuery';
import theme from '@/utils/styles-variables';
import Portal from '@/utils/create-portal';

const HeroJuneThematicContent = ({
  buttonLabel,
  client,
  label,
  openModal,
  subtitle,
  title,
  upperLabel,
  userName,
}) => {
  const enrollButton = (isFixed = false) => (
    <EnrollButton
      id={isFixed ? 'fixed_header_button' : 'header_button'}
      className="button"
      isActive={client.isActive}
      openModal={() => openModal({ buttonText: buttonLabel, buttonLocation: 'header' })}
      client={client}
      buttonLabel={buttonLabel}
      product={client?.product}
      redirectToApp={client?.redirectToApp}
    />
  );

  const isMobile = useBetterMediaQuery(`(max-width: ${theme.breakpoints.max_sm}px)`);
  const [ref, inView, entry] = useInView({
    threshold: 1,
    initialInView: true,
    rootMargin: '-10px',
  });

  const shouldShowFixedButton = isMobile && !inView && entry?.boundingClientRect?.top < 100;

  return (
    <Content>
      {upperLabel && <UpperLabel>{upperLabel}</UpperLabel>}

      <Heading as="h1" size="3xl" weight="bold">
        {formattedTitle({ title, userName })}
      </Heading>

      {subtitle && <Subtitle className="notGradient">{subtitle}</Subtitle>}

      <ButtonWrapper ref={ref}>
        {enrollButton(false)}
        {label && <ExtraLabel>{label}</ExtraLabel>}
      </ButtonWrapper>

      {shouldShowFixedButton && (
        <Portal portalId="sticky-enroll-button-portal">
          <FixedWrapper $visible={shouldShowFixedButton}>
            <EnrollButtonWrapper>
              <EnrollContainer>{enrollButton(true)}</EnrollContainer>
            </EnrollButtonWrapper>
          </FixedWrapper>
        </Portal>
      )}
    </Content>
  );
};

export default HeroJuneThematicContent;
